import { use } from 'react';
import { twMerge } from 'tailwind-merge';

import { FormContext } from './FormContext';

interface Props {
  className?: string;
}

export function FormError(props: Props) {
  const { error } = use(FormContext);

  if (error) {
    let displayError = error;

    // Parse TRPC validation errors that might be stringified
    if (typeof error === 'string') {
      if (error.startsWith('[') && error.includes('"validation"')) {
        try {
          const parsed = JSON.parse(error);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].message) {
            displayError = parsed[0].message;
          }
        } catch {
          // If parsing fails, try to extract message with regex
          const messageMatch = error.match(/"message":\s*"([^"]+)"/);
          if (messageMatch?.[1]) {
            displayError = messageMatch[1];
          }
        }
      } else if (error.includes('TRPCClientError')) {
        // Extract just the message from the error string
        const messageMatch = error.match(/"message":\s*"([^"]+)"/);
        if (messageMatch?.[1]) {
          displayError = messageMatch[1];
        }
      }
    }

    return (
      <div className={twMerge('text-xs', 'text-rose-500', props.className)}>
        {displayError}
      </div>
    );
  } else {
    return null;
  }
}
